export default __webpack_public_path__ + "static/media/Rectangle34.f55e4980.png";